import { colorPageSlugs } from '@boss/constants/b2b-b2c';
import { useRouter } from '@boss/hooks';
import { twMerge } from 'tailwind-merge';

import { FavoriteButton, Link, Orb, PaintDrop, Skeleton } from '../../index';
import { ColorButtonProps } from '../index';

const SecondaryColorButton = ({
  active,
  backgroundColor,
  className,
  colorType,
  id,
  isFavorite,
  loading,
  name,
  onClick,
  onClickAction,
  onFavorite,
  slug,
  trackInfo,
  translations,
  trending,
}: ColorButtonProps) => {
  const { locale } = useRouter();

  if (loading) {
    return (
      <div className={twMerge('flex flex-col items-center gap-3', className)}>
        <Orb className="shadow-lg" loading size="xl" />
        <div className="flex flex-col items-center gap-2">
          <Skeleton className="w-15 h-3" />
          <Skeleton className="h-3 w-10" />
        </div>
      </div>
    );
  }

  return (
    <div className={twMerge('relative w-full', className)}>
      <Link
        className="relative flex w-full flex-col items-center gap-3"
        href={onClickAction === 'navigate' ? `${colorPageSlugs[locale]}/${slug}` : undefined}
        onClick={onClick}
        trackInfo={trackInfo}
      >
        <div className="group/drop relative">
          <svg
            className={twMerge(
              'stroke-colorButtonSecondary-active-border pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity group-hover/drop:opacity-100',
              active && 'opacity-100',
            )}
            fill="none"
            height="84"
            viewBox="-6 -6 90 84"
            width="90"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37.7419 0.5C47.1592 0.5 57.1119 4.84514 64.7157 11.3929C72.3243 17.9448 77.5 26.6293 77.5 35.2448C77.5 43.8998 73.2934 52.9669 66.3867 59.8773C59.4845 66.7832 49.9201 71.5 39.2516 71.5C17.7992 71.5 0.5 57.544 0.5 38.7692C0.5 19.8642 15.4189 0.5 37.7419 0.5Z"
              strokeWidth="2"
              transform="translate(39, 36) scale(1.12) translate(-39, -36)"
            />
          </svg>
          <PaintDrop colorCode={backgroundColor} colorType={colorType} />
          {trending && translations && (
            <span className="caption bg-colorButton-trending-badge-bg text-colorButton-trending-badge-text rounded-colorButton-trending-badge px-colorButton-trending-badge-x py-colorButton-trending-badge absolute -right-2 bottom-0 font-bold">
              {translations.trending}
            </span>
          )}
        </div>
        {(id || name) && (
          <div className="flex flex-col items-center">
            {id && <span className="caption text-center">{id}</span>}
            {name && <span className="caption text-center">{name}</span>}
          </div>
        )}
      </Link>
      {onFavorite && (
        <FavoriteButton
          className="absolute -top-2 left-1/2 translate-x-[calc(-50%+2rem)]"
          isFavorite={isFavorite}
          onClick={onFavorite}
        />
      )}
    </div>
  );
};

export default SecondaryColorButton;
